import React, { useState } from 'react';
import type { Ctx } from '../ctx';
import { saveBlob } from '../files';
import { Icon } from '../icons';
import { ErrorBanner, Panel } from '../ui';

/** Scarica il file che installa Sentinel sui PC dei clienti. */
export async function downloadSentinelSetup(ctx: Ctx): Promise<void> {
  saveBlob(await ctx.api.download('/api/downloads/sentinel'), 'Setup Sentinel.exe');
}

/** Download: i programmi da portare dai clienti. */
export function DownloadsPage({ ctx }: { ctx: Ctx }) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const download = async () => {
    setError(null);
    setBusy(true);
    try { await downloadSentinelSetup(ctx); }
    catch (e) { setError((e as Error).message); }
    finally { setBusy(false); }
  };
  return (
    <div className="panels single">
      <Panel title="Download" subtitle="I programmi da portare sui PC dei clienti">
        <ErrorBanner message={error} onClose={() => setError(null)} />
        <div className="ag-row">
          <Icon name="shield" size={20} />
          <span className="ag-title">
            <b>Sentinel</b>
            <div className="muted small">Copialo sul PC del cliente, aprilo e inserisci il nome del PC e il codice di licenza.</div>
          </span>
          <button type="button" className="btn dark" disabled={busy} onClick={() => void download()}>
            {busy ? 'Scarico…' : 'Scarica Setup Sentinel.exe'}
          </button>
        </div>
      </Panel>
    </div>
  );
}
